import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";

function pinIcon(active) {
  const color = active ? "#F36353" : "#B99B4A";
  const html = `<svg class="bp-pin" width="34" height="42" viewBox="0 0 34 42" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 0C8.2 0 1 7.1 1 15.9C1 27 17 42 17 42s16-15 16-26.1C33 7.1 25.8 0 17 0z" fill="${color}"/>
    <circle cx="17" cy="16" r="6.4" fill="#fff"/>
  </svg>`;
  return L.divIcon({ html, className: "", iconSize: [34, 42], iconAnchor: [17, 42], popupAnchor: [0, -38] });
}

function userIcon() {
  const html = `<div style="width:16px;height:16px;border-radius:50%;background:#748C70;border:3px solid #fff;box-shadow:0 0 0 4px rgba(116,140,112,0.3)"></div>`;
  return L.divIcon({ html, className: "", iconSize: [16, 16], iconAnchor: [8, 8] });
}

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, map.getZoom(), { animate: true });
  }, [center, map]);
  return null;
}

export default function PlazaMap({ studies, center, userLoc, height = "100%" }) {
  const nav = useNavigate();
  const fallback = center || [39.5, -98.35];
  const zoom = center ? 11 : 4;
  return (
    <MapContainer center={fallback} zoom={zoom} style={{ height, width: "100%" }} scrollWheelZoom data-testid="plaza-map">
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Recenter center={center} />
      {userLoc && <Marker position={userLoc} icon={userIcon()} />}
      {studies.map((s) => (
        <Marker key={s.id} position={[s.venue.lat, s.venue.lng]} icon={pinIcon(s.active)}>
          <Popup>
            <div style={{ minWidth: 180 }}>
              <div style={{ fontWeight: 700, fontFamily: "Outfit, sans-serif", marginBottom: 2 }}>{s.title}</div>
              <div style={{ fontSize: 12, color: "#6B6763" }}>{s.venue.name}</div>
              <div style={{ fontSize: 12, color: "#6B6763", marginBottom: 6 }}>
                {s.schedule.day_name}s · {s.schedule.start_time}
              </div>
              <button
                onClick={() => nav(`/study/${s.id}`)}
                data-testid={`map-popup-view-${s.id}`}
                style={{ background: "#F36353", color: "#fff", border: "none", borderRadius: 999, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
              >
                View study
              </button>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
